type Props = {
  onSizeSelect: (size: string) => void;
  selectedSize?: string;
  sizes: string[];
};

const baseClassNames = 'text-center py-2 rounded-md cursor-pointer';

const SizeSelectorGrid = ({ onSizeSelect, selectedSize, sizes }: Props) => {
  const selectedClassNames = 'bg-forest text-white';
  const unselectedClassNames = 'bg-concrete text-black';

  return (
    <div
      className="grid w-full grid-cols-4 gap-2 gap-y-4 bg-white"
      data-cy="size-selector-grid"
    >
      <button
        className={`${baseClassNames} ${
          !selectedSize ? selectedClassNames : unselectedClassNames
        }`}
        onClick={() => onSizeSelect('')}
      >
        All sizes
      </button>
      {sizes.map((size) => (
        <button
          data-cy="size-selector-button"
          key={size}
          className={`${baseClassNames} ${
            selectedSize === size ? selectedClassNames : unselectedClassNames
          } rounded`}
          onClick={() => onSizeSelect(size)}
        >
          {size}
        </button>
      ))}
    </div>
  );
};

export default SizeSelectorGrid;
